
export default {
  productData: {
    serialNumber: 'DA-MME-002',
    name: 'Massivholzdecke mit Estrich l Aufbau 2',
    construction: {
      composition: [
        {
          type: 'screed',
          title: { de: 'Estrich' },
          output: '≥ 60',
          value: 'w-60'
        },
        {
          type: 'insulation',
          title: { de: 'Mineralwolledämmplatte MW<br>(<i>s‘</i> ≤ 10 MN/m<sup>3</sup>; Anwendungsgebiet DES-sh)' },
          output: '≥ 20',
          value: 'm-20'
        },
        {
          type: 'fill',
          title: { de: 'Mit StoPrefa Coll SB gebundene Schüttung (<i>m‘</i> ≥ 190 kg/m<sup>2</sup>), Rieselschutz' },
          output: '≥ 120',
          value: 'scsb-120'
        },
        {
          type: 'supportingStructure',
          title: { de: 'Massivholzdecke (Steico GLVL)' },
          output: 120,
          value: 'mh-120'
        }
      ],
      sum: {
        output: '320', value: 320
      }
    },
    technicalValues: {
      impactSoundLevel: { // L,nw
        output: '41 (-4; 1)',
        value: 41
      },
      soundReductionIndex: { // Rw
        output: '80 (-2; -6)',
        value: 80
      },
      heatTransferCoefficient: { // U-Wert
        output: '0,47',
        value: 0.47
      },
      fireResistance: {
        output: 'F 30-B',
        value: 'F-30-B'
      },
      massPerUnitArea: {
        output: '412 [kg/m²]'
      }
    }
  },
  image: 'da-mme-002.png',
  pdf: 'Massivholzdecke-mit-Estrich-Aufbau-2-DA-MME-002-Rev01.pdf'
}
